import { Card } from "../components/Card";
import PhotosList from "../components/PhotoList";
import VideoList from "../components/VideoList";

export default function Photos() {

  return (
    <>
      <h1>Photos and Videos</h1>
      <Card id="photos" className="photos" bgc="fill" title="Reunion Photos & Video">
        <p>
          Several people have contributed photos from previous Conner family reunions.  Please
          click on a year and event below to display the photo gallery for that event.
        </p>
        <p>
          If you have previous family reunion photos you would like to include on the web site,
          please <a href="mailto:richkindle@me.com">email Rich Kindle</a> to determine the
          best way to get those images posted here on the site.
        </p>
        <div className="pvid-container">
          <div className="photolist">
            <PhotosList />
          </div>
          <div className="videolist">
            <VideoList />
          </div>
        </div>
      </Card>
    </>
  );
}


